export const STATUS_OPTIONS = [
    { label: "Not Submitted", value: "NotSubmitted" },
    { label: "Approved", value: "Approved" }
];

export const APPROVED_STATUS = {
    APPROVED: 'Approved',
}

